(function () {
  //최근검색어
  var recentItemTemplate =
    '<li><span class="box"><a href="#{{text}}" data-contents="최근 검색어">{{text}}</a><button type="button" class="btn-delete" title="검색어 삭제"><span class="blind">삭제</span></button></span></li>';
  //인기검색어
  var popularItemTemplate =
    '<li><a href="#{{text}}" data-contents="인기 검색어"><b>{{index}}.</b> {{text}}</a></li>';
  //자동완성
  var autoCompleteItemTemplate =
    '<li><a href="#{{input}}">{{#raw text}}</a><button class="keyword_select" data-contents="{{input}}" >검색어선택</button></li>';
  //자동완성 상품리스트
  var autoCompletePrductListTemplate = 
	'<li>' + 
	'<a href="{{modelUrlPath}}" >' + 
	'    <span class="prod-img"><img src="{{_imageUrl}}"  onError="lgkorUI.addImgCateErrorEvent(this, \'{{noImageUrl}}\' );" alt="{{modelName}}"></span>' + 
	'    <div class="model-info">' + 
	'        <p class="model-name">{{#raw _modelName}}</p> <!-- 검색어와 일치한 단어의 srch-word 추가 -->' + 
	'        <div class="prod-path">' + 
	'            <span>{{superCategoryName}}</span>' + 
	'            <span>{{categoryName}}</span>' + 
	'        </div>' + 
	'    </div>' + 
	'    <span class="txt-direct">제품 바로가기</span>' + 
	'</a>' + 
	'</li>'; 
  //연관검색어
  var similarTextTemplate =
    '<a href="#{{text}}" class="similar-text"><span class="search-word">{{text}}</span> 찾으시나요?</a>';

  // 최근검색어 저장 공유 도메인 e.g. ".lge.co.kr"
  var lgeHost = location.hostname.replace(/.+(?=lge\.)/i, ".");

  var linkHost =
    window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";

  var intergratedSearch = {
    init: function () {
      var self = this;
      self.setting();
      self.bindEvents();
    },

    setting: function () {
      var self = this;

      //타이머
      self.searchTimer = null;

      //통합검색 레이어
      self.$searchLayer = $("#layerSearch");

      //검색어 입력input
      self.$inputSearch = self.$searchLayer.find("div.input-sch input.txt");
      self.$inputSearch.attr("data-autofocus", true);
      self.$inputSearch.val('');
      //검색버튼
      self.$buttonSearch = self.$searchLayer.find(
        "div.input-sch button.btn-search"
      );
      self.$cameraSearch = self.$searchLayer.find(
        "div.input-sch button.btn-camera"
      );
      //검색 전 리스트 공간
      self.$searchKeywordArea = self.$searchLayer.find(
        "div.search-keyword-area"
      );
      //최근 검색어 리스트
      self.$recentKeywordList =
        self.$searchKeywordArea.find("div.recent-keyword");
      //인기 검색어 리스트
      self.$popularKeywordList = self.$searchKeywordArea.find(
        "div.popular-keyword"
      );
      //자동 완성 & 검색 결과 공간
      self.$searchResultArea = self.$searchLayer.find("div.search-result-area");
      //자동 완성 리스트
      self.$autoComplete = self.$searchResultArea.find("div.auto-complete");
      //검색 결과
      self.$resultPreview = self.$searchResultArea.find("div.result-preview");
      //검색 결과 - 리스트
      self.$resultPreviewList = self.$resultPreview.find(
        "div.result-preview-list"
      );
      //연관검색어 ("xxx" 를 찾은시나요?)
      self.$searchSimilar = self.$searchLayer.find("div.search-similar");
      //돋보기 숨김
      $('li.search>a[href="#layerSearch"]').removeAttr("data-control");
      self.$searchLayer.attr("aria-hidden", true); // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인
      self.hideSearchResultArea();
      self.$searchSimilar.hide();
      self.toggleCamera(true);
    },

    sendSearchPage: function (searchUrl, search, force) {
      if (searchUrl) {
        var fi = searchUrl.indexOf("?");
        var url =
          searchUrl +
          (fi < 0 ? "?" : "&") +
          "search=" +
          encodeURIComponent(search) +
          "&force=" +
          force;
        location.href = url;
      }
    },

    bindEvents: function () {
      var self = this;

      $('li.search>a[href="#layerSearch"]')
        .off(".intergrated")
        .on("click.intergrated", function (e) {
          // 검색모달페이지 스크롤 중간 위치하는 경우 수정
          self.preScrollTop = $(window).scrollTop();
          $(window).scrollTop(0);
          e.preventDefault();
          self.updateBasicData();
          self.updateRecentSearchList();
          //self.openSearchPopup();
          //직접 구문이 작성되야 최신아이폰에서 포커스시 키보드가 열린다

          self.$searchLayer.attr("aria-hidden", false).addClass("open");
          self.$inputSearch.focus();
          self.$inputSearch.val('');
          self.hideSearchResultArea();
          self.openSearchInputLayer(true);
          var ignoreOverflow = $("body").hasClass("ignore-overflow-hidden");
          if (!ignoreOverflow) {
            // scroll-lock 클래스 추가 : 팝업 뛰울시 바닥페이지 스크롤 밀림 방지 class
            $("body").addClass("scroll-lock");
          }
          // 스크롤 이중 노출되는 현상
          $('html').css('overflow-y', 'auto');

            // 모바일웹,앱 하단메뉴 노출 여부 설정
            lgkorUI.showBottomMeun(false)
        });

      //통합검색 닫음
      self.$searchLayer
        .find("button.btn-close")
        .off(".intergrated")
        .on("click.intergrated", function (e) {
          e.preventDefault();

          self.closeSearchPopup();
          // 검색모달페이지 스크롤 중간 위치하는 경우 수정
          if(self.preScrollTop){
            $(window).scrollTop(self.preScrollTop);
          }

            // 모바일웹,앱 하단메뉴 노출 여부 설정
            lgkorUI.showBottomMeun(true)
        });

      //검색버튼
      self.$buttonSearch
        .off(".intergrated")
        .on("click.intergrated", function (e) {
          e.preventDefault();
          clearTimeout(self.searchTimer);

          var url = self.$searchLayer.data("allUrl");
          var searchVal = self.$inputSearch.val();
          self.sendSearchPage(url, searchVal, false);
        });

      self.$inputSearch.keydown(function (key) {
        if (key.keyCode == 13) {
          key.preventDefault();
          self.$buttonSearch.trigger("click");
        }
        // 키보드 
        if (key.keyCode == 38 || key.keyCode == 40) { 
          var $links = self.$autoComplete.find('div.keyword-list ul li'),
          linkIndex =   0
          count = $links.length;
          if(count > 0 ){ 
            $links.each(function( index, element ) {
              if ($(element).hasClass("on") ) linkIndex = index+1;
              $(element).removeClass("on")
            });
            switch (key.keyCode) {
                case 38:
                    // up
                    linkIndex = Math.max(0, linkIndex - 1) ; 
                    break;
                case 40:
                    // down
                    linkIndex = Math.min(count, linkIndex + 1) ; 
                    break;
            }
            if(linkIndex > 0 ) linkIndex = linkIndex -1;  
            $links.eq(linkIndex).addClass('on'); 
            self.$inputSearch.val($links.eq(linkIndex).find('a').attr("href").replace("#", ""));
          }
        }
      });

      // 카메라버튼
      self.$cameraSearch.on("click", function (e) {
        var target = $(e.currentTarget);

        self.callCheckLogin(function (result) {
          var uri = "/my-page/manage-products";

          if (!result.data.isLogin) {
            lgkorUI.alert(
              "<h6>보유제품을 등록하시려면<br />로그인이 필요합니다.</h6>",
              {
                ok: function () {
                  // 보유제품 페이지로 던지면 미로그인시 로그인 페이지로 가기에
                  if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
                },
              },
              target
            );
          } else {
            if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
          }
        });
      });

      //검색 타이머
      self.$inputSearch
        .off(".intergrated")
        .on("input.intergrated", function (e) {
          clearTimeout(self.searchTimer);

          // 자동완성 공백 특수문자 단독 입력시 호출되지 않도록 처리
          var reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
          var searchVal = this.value.trim();
          var searchTestVal = searchVal.replace(reg, "");
          if (searchVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH || searchTestVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH) {
            self.openSearchInputLayer(true);
            self.hideSearchResultArea();
            self.$searchSimilar.hide();
            self.toggleCamera(true);
            return;
          } else {
            self.searchTimer = setTimeout(function () {
              self.requestSearchAutoComplete(searchVal);
            }, lgkorUI.SEARCH_AUTOCOMPLETE_TIMER);
            self.toggleCamera(false);
          }
        });

      //자동완성 리스트 클릭
      self.$autoComplete
        .off(".intergrated")
        .on("click.intergrated", "div.keyword-list ul li a", function (e) {
          e.preventDefault();
          self.searchItem($(this));
        });

      //자동완성 화살표 클릭
      self.$autoComplete.on(
        "click.intergrated",
        "div.keyword-list ul li button",
        function (e) {
          e.preventDefault();
          self.searchItem($(this).prev("a"), false);

          self.$inputSearch.focus();
        }
      );

      //연관검색어 클릭
      self.$searchSimilar
        .off(".intergrated")
        .on("click.intergrated", "a", function (e) {
          e.preventDefault();
          self.searchItem($(this));
        });

      //인기검색어 클릭
      self.$popularKeywordList
        .off(".intergrated")
        .on("click.intergrated", "div.keyword-list ul li a", function (e) {
          e.preventDefault();
          self.searchItem($(this));
        });

      //최근검색어 클릭
      self.$recentKeywordList
        .off(".intergrated")
        .on("click.intergrated", "div.keyword-list ul li span a", function (e) {
          e.preventDefault();
          self.searchItem($(this));
        })
        .on(
          "click.intergrated",
          "div.keyword-list ul li span button",
          function (e) {
            //최근검색어 삭제 클릭
            var text = $(this)
              .siblings("a")
              .first()
              .attr("href")
              .replace("#", "");
            self.removeRecentSearcheText(text);
          }
        )
        .on("click.intergrated", ".all-delete > a", function (e) {
          e.preventDefault();
          self.removeRecentSearcheText();
        });
    },

    /**
     * 로그인 체크
     */
    callCheckLogin: function (callback) {
      var ajaxUrl = $("header").data("login-info");

      if (!ajaxUrl) {
        return;
      }

      lgkorUI.requestAjaxDataPost(
        ajaxUrl,
        {},
        function (result) {
          if (callback) callback(result);
        }.bind(this)
      );
    },

    openSearchPopup: function () {
      var self = this;
      self.$searchLayer.attr("aria-hidden", false).addClass("open");

      self.$inputSearch.focus();

      //
      var ignoreOverflow = $("body").hasClass("ignore-overflow-hidden");
      if (!ignoreOverflow) {
        $("html, body").css({
          overflow: "hidden",
        });
      }
    },

    closeSearchPopup: function () {
      var self = this;
      clearTimeout(self.searchTimer);
      self.$searchLayer.attr("aria-hidden", true).removeClass("open");

      var ignoreOverflow = $("body").hasClass("ignore-overflow-hidden");
      if (!ignoreOverflow) {
        // scroll-lock 클래스 추가 : 팝업 뛰울시 바닥페이지 스크롤 밀림 방지 class
        $("body").removeClass("scroll-lock");
      }
    },

    //검색어창에 입력후 검색
    searchItem: function ($item, isTrigger) {
      var self = this;
      var trigger = isTrigger === undefined ? true : isTrigger;

      var searchVal = $item.attr("href").replace("#", "");
      self.$inputSearch.val(searchVal);

      if (trigger) {
        self.$buttonSearch.trigger("click");
        self.closeSearchPopup();
      }
    },

    /**
     * 카메라 버튼 토글
     * @param {boolean} show
     */
    toggleCamera: function (show) {
      var self = this;

      if (isApp() && show) {
        self.$buttonSearch.hide();
        self.$cameraSearch.show();
      } else {
        self.$buttonSearch.show();
        self.$cameraSearch.hide();
      }
    },

    openSearchInputLayer: function (open) {
      var self = this;
      if (open) {
        self.updateRecentSearchList();
        self.$searchKeywordArea.show();
      } else {
        self.$searchKeywordArea.hide();
      }
    },

    hideSearchResultArea: function () {
      var self = this;
      //자동완성
      self.$autoComplete.hide();
      //검색 결과
      self.$resultPreview.hide();
      //검색 결과 - 리스트
      self.$resultPreviewList.hide();
    },

    //검색어 입력중 검색
    requestSearchAutoComplete: function (value) {
      var self = this;
      var ajaxUrl = self.$searchLayer.data("autocompleteUrl");
      lgkorUI.requestAjaxData(ajaxUrl, { search: value }, function (result) {
        var param = result.param;
        var data = result.data;

        var searchedValue = param.search;
        var replaceText =
          '<span class="search-word">' + searchedValue + "</span>";
        var showAutoComplete = false;

        //자동완성 리스트 갱신
        var arr = data && data.listData instanceof Array ? data.listData : [];
        var $list_ul = self.$autoComplete.find("div.keyword-list ul");
        $list_ul.empty();
        if (arr.length > 0) {

          arr.forEach(function (item, index) {
            $list_ul.append(
              vcui.template(autoCompleteItemTemplate, {
                input: item,
                text: vcui.string.replaceAll(
                  item,
                  searchedValue,
                  replaceText
                ),
              })
            );
          });
          showAutoComplete = true;
        }

        // [BTOCSITE-86615] 사업자몰(B2B) 구독 도입 : 자동완성 키워드 제거
        var $prductList_div = self.$autoComplete.find("div.prod-direct-list");
        $prductList_div.hide();
        var $brandhall_div = self.$autoComplete.find("div.brandhall");
        $brandhall_div.hide();
        //// [BTOCSITE-86615] 사업자몰(B2B) 구독 도입 : 자동완성 키워드 제거

        //자동완성 리스트 갱신
        if (showAutoComplete) {
          self.$autoComplete.show();
          self.openSearchInputLayer(false);
          self.$searchSimilar.hide();
        } else {
          self.hideSearchResultArea();
          //연관검색어가 있으면 연관검색어를 표시하고 아니면 숨기기
          if (data.similarText) {
            self.$searchSimilar.html(
              vcui.template(similarTextTemplate, { text: data.similarText })
            );
            self.$searchSimilar.show();
            self.openSearchInputLayer(false);
          } else {
            self.$searchSimilar.hide();
            self.openSearchInputLayer(true);
          }
        }
      });
    },

    //최근 검색어 삭제
    removeRecentSearcheText: function (text) {
      var self = this;

      // 쿠키 *.lge.co.kr 에 공유하기 위함
      lgkorUI.cookieDomain = lgeHost;

      if (text) {
        lgkorUI.removeCookieArrayValue(lgkorUI.INTERGRATED_SEARCH_VALUE_B2B, text);
      } else {
        lgkorUI.deleteCookie(lgkorUI.INTERGRATED_SEARCH_VALUE_B2B);
      }

      self.updateRecentSearchList();

      lgkorUI.cookieDomain = null;
    },

	//최근 검색어 추가
	addRecentSearcheText: function (text) {
		// 스페이스바(공백제거) & 특수문자 치환(¡¿¡)
		var _text = text.trim().replaceAll('|','').replaceAll('&','¡¿¡');

		if (!_text || _text.length < 1) return;
		var self = this;

		// 쿠키 *.lge.co.kr 에 공유하기 위함
		lgkorUI.cookieDomain = lgeHost;
		lgkorUI.addCookieArrayValue(lgkorUI.INTERGRATED_SEARCH_VALUE_B2B, _text, lgkorUI.MAX_SAVE_RECENT_KEYWORD_B2B);
		self.updateRecentSearchList();

		lgkorUI.cookieDomain = null;
	},

    //최근 검색어 리스트 갱신
    updateRecentSearchList: function () {
      var self = this;

      var cookieValue = lgkorUI.getCookie(lgkorUI.INTERGRATED_SEARCH_VALUE_B2B);
      var searchedList = cookieValue ? cookieValue.split("|") : [];

      var arr = searchedList instanceof Array ? searchedList : [];
      var $list_ul = self.$recentKeywordList.find("div.keyword-list ul");
      $list_ul.empty();
      if (arr.length > 0) {
        arr.forEach(function (item, index) {
          var _text = item.trim().replaceAll('¡¿¡','&');
          if(_text) {
              $list_ul.append(vcui.template(recentItemTemplate, { text: _text }));
          }
        });
        self.$recentKeywordList.show();
        self.$recentKeywordList.find("div.no-data").hide();
      } else {
        self.$recentKeywordList.hide();
        self.$recentKeywordList.find("div.no-data").show();
      }
    },

    //기초 데이타 갱신
    updateBasicData: function () {
      var self = this;
      var ajaxUrl = self.$searchLayer.data("basicUrl");
      lgkorUI.requestAjaxData(ajaxUrl, null, function (result) {
        var data = result.data;

        //인기검색어
        var arr =
          data.popular && data.popular instanceof Array ? data.popular : [];

        if (arr.length > 0) {
          var $list = self.$popularKeywordList.find("div.keyword-list");
          $list.empty().append("<ul></ul>");
          if (arr.length > 5) $list.append("<ul></ul>"); // 5개 이상 때 추가 ul
          $list_ul = $list.find("> ul");

          arr.forEach(function (item, index) {
            $list_ul.eq(Math.floor(index / 5)).append(
              vcui.template(popularItemTemplate, {
                text: item,
                index: index + 1,
              })
            );
          });
          self.$popularKeywordList.show();
        } else {
          self.$popularKeywordList.hide();
        }
      });
    },
  };

  $(document).ready(function () {
    intergratedSearch.init();
  });
})();
